module.exports = __webpack_public_path__ + "static/media/default.cbcf5f91.jpg";